module.exports = __webpack_public_path__ + "static/2-Yoga-43205285d10b1520826987e45a8bdd3a.png";